import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { team } from 'redux/modules'
import Loader from './Loader'
import { WRONG_PERMISSION_ROUTE } from 'constants/routes'

const TeamLoader = ({
  additionalParams,
  children,
  teamUuid,
  fetchTeam,
  ...restProps
}) => {
  return (
    <Loader
      fetchMethod={(params) => {
        return fetchTeam(teamUuid, {
          ...params,
          ...additionalParams,
          include: ['ageClass', 'logo'],
        }).then((res) => {
          const teamData = res.response.data

          // If team data is not available, redirect to the wrong permission route to prevent unauthorized access
          if (!teamData) {
            window.location.href = WRONG_PERMISSION_ROUTE
          }

          const canViewTeamDashboard = teamData.can.some(
            (permission) => permission === 'access-team-via-web-app'
          )

          // This security check helps to restrict players to open team dashboard using direct link
          if (!canViewTeamDashboard) {
            window.location.href = WRONG_PERMISSION_ROUTE
          }
        })
      }}
      triggers={[teamUuid]}
      {...restProps}
    >
      {children}
    </Loader>
  )
}

TeamLoader.defaultProps = {
  additionalParams: {},
}

TeamLoader.propTypes = {
  children: PropTypes.node.isRequired,
  teamUuid: PropTypes.string.isRequired,
  fetchTeam: PropTypes.func.isRequired,
  additionalParams: PropTypes.shape(),
}

export default connect(null, {
  fetchTeam: team.fetchTeam,
})(TeamLoader)
